import React from 'react';
import MainNavbar from './MainNavbar';
import Footer from './Footer';

export default function PageWithNavbar({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <MainNavbar />
      <div style={{ paddingTop: 14, flex: 1 }}>
        {children}
      </div>
      <Footer />
    </div>
  );
}
